import {Component, inject, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {ToastMessage, ToastService} from "../../../services/toast.service";

@Component({
  selector: 'toasts',
  templateUrl: './toasts.component.html',
  standalone: false
})
export class ToastsComponent implements OnInit {
  toasts: Observable<ToastMessage[]>;

  private readonly toastService = inject(ToastService);

  constructor() {
    this.toasts = this.toastService.toasts;
  }

  ngOnInit() {
    this.toasts = this.toastService.toasts;
  }

  closeToast(toast: ToastMessage) {
    this.toastService.removeToast(toast);
  }
}
